import { render, staticRenderFns } from "./AppSignupOneTimePassConfirmPage.vue?vue&type=template&id=6fe0f386"
import script from "./AppSignupOneTimePassConfirmPage.vue?vue&type=script&lang=ts"
export * from "./AppSignupOneTimePassConfirmPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports